import React from 'react';
import PropTypes from 'prop-types';
import PageOverlay from 'components/PageOverlay';
import ResizingIFrame from 'components/ResizingIFrame';
import RootClasses from 'utils/RootClasses';
import { getToken } from 'utils/auth';
import { isMobileDevice_DEPRECATED } from 'utils/mode';
import './MicrositePage.css';

function MicrositePage({
  className,
  url,
  title,
  showTitleHeader = false,
  passToken = false,
  scrolling = false,
  resizing = false,
  iframeRef = undefined,
  onClick = undefined,
  wrapperComponent: Wrapper = undefined,
  ...rest
}) {
  if (Wrapper === undefined && !isMobileDevice_DEPRECATED()) {
    Wrapper = PageOverlay;
  }

  let query = '';
  if (passToken) {
    const token = getToken();
    query = token ? `token=${token}` : '';
  }

  let fullUrl = url;
  if (query) {
    fullUrl += (fullUrl.indexOf('?') !== -1 ? '&' : '?') + query;
  }

  const IFrameComponent = resizing ? ResizingIFrame : 'iframe';
  const setClassName = `microsite-page ${className || ''}${
    resizing ? ' resizing' : ''
  }`;

  let content = (
    <div className={setClassName}>
      <h1 className="sr-only">{title}</h1>
      {isMobileDevice_DEPRECATED() && (
        <RootClasses className="background-white" />
      )}
      {showTitleHeader && <div className="title">{title}</div>}
      <IFrameComponent
        title={title}
        src={fullUrl}
        scrolling={scrolling ? 'yes' : 'no'}
        ref={iframeRef}
        {...rest}
      />
    </div>
  );

  if (Wrapper) {
    content = <Wrapper children={content} onClick={onClick} />;
  }

  return content;
}

MicrositePage.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  showTitleHeader: PropTypes.bool,
  passToken: PropTypes.bool,
  resizing: PropTypes.bool,
  scrolling: PropTypes.bool,
  iframeRef: PropTypes.func,
  wrapperComponent: PropTypes.any
};

export default MicrositePage;
